"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeaderboardUserListTable = exports.LeaderboardSkeleton = exports.LeaderboardEmptyMessage = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Medal = _interopRequireDefault(require("@insided/destination/icons/Medal"));

var _User = _interopRequireDefault(require("@insided/destination/icons/User"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../User/UserName"));

var _Pagination = _interopRequireDefault(require("../../shared/uikit/Pagination"));

var _utils = require("./utils");

/* eslint-disable classnames/prefer-classnames-function */
var LeaderboardUserListTable = function LeaderboardUserListTable(_ref) {
  var usersList = _ref.usersList,
      currentUser = _ref.currentUser,
      showCurrentlyLoggedInUserSection = _ref.showCurrentlyLoggedInUserSection,
      totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      generateNewUrl = _ref.generateNewUrl,
      loggedInUserId = _ref.loggedInUserId;
  return (0, _preact.h)("div", {
    className: "leaderboard-table-container"
  }, (0, _preact.h)("section", {
    className: "leaderboard-table"
  }, (0, _preact.h)("header", null, (0, _preact.h)(LeaderboardHeaderRow, null)), showCurrentlyLoggedInUserSection && (0, _preact.h)(LeaderboardUserRow, {
    isLoggedInUser: true,
    customClass: "leaderboard-row-current-user",
    user: currentUser
  }), (0, _preact.h)("div", {
    className: "leaderboard-table-body"
  }, usersList.map(function (user) {
    return (0, _preact.h)(LeaderboardUserRow, {
      key: user.id.toString(),
      user: user,
      isLoggedInUser: user.id === loggedInUserId,
      customClass: user.id === loggedInUserId ? 'highlight-row' : ''
    });
  }, {
    currentUser: currentUser
  }), totalPages > 1 && (0, _preact.h)(_Pagination.default, {
    totalPageCount: totalPages,
    currentPage: currentPage,
    generateNewUrl: generateNewUrl
  }))));
};

exports.LeaderboardUserListTable = LeaderboardUserListTable;

var LeaderboardSkeleton = function LeaderboardSkeleton(_ref2) {
  var isLoading = _ref2.isLoading;
  var placeholderArray = [1, 2, 3];
  return (0, _preact.h)("div", {
    className: "leaderboard-table-container"
  }, (0, _preact.h)("section", {
    className: "leaderboard-table"
  }, (0, _preact.h)("header", null, (0, _preact.h)(LeaderboardHeaderRow, null)), (0, _preact.h)("div", {
    className: "leaderboard-table-body"
  }, placeholderArray.map(function (item) {
    return (0, _preact.h)(LeaderboardPlaceholderRow, {
      key: item.toString(),
      isLoading: isLoading,
      leaderboardPosition: item
    });
  }))));
};

exports.LeaderboardSkeleton = LeaderboardSkeleton;

var LeaderboardEmptyMessage = function LeaderboardEmptyMessage() {
  return (0, _preact.h)("div", {
    className: "leaderboard-empty-message-container"
  }, (0, _preact.h)("div", {
    className: "leaderboard-empty-message"
  }, (0, _preact.h)("h2", {
    className: "leaderboard-empty-message-title h5"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.weekly.empty.title"
  })), (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.weekly.empty.description"
  }))));
};

exports.LeaderboardEmptyMessage = LeaderboardEmptyMessage;

var LeaderboardPlaceholderRow = function LeaderboardPlaceholderRow(_ref3) {
  var leaderboardPosition = _ref3.leaderboardPosition,
      isLoading = _ref3.isLoading;
  return (0, _preact.h)("div", {
    className: "leaderboard-row placeholder-row ".concat(isLoading ? 'loading' : '')
  }, (0, _preact.h)("div", {
    className: "ranking-cell right"
  }, (0, _preact.h)(_Medal.default, {
    className: "icon-medal is-hidden-S"
  }), (0, _preact.h)("span", {
    className: "ranking-number"
  }, " ", leaderboardPosition, " ")), (0, _preact.h)("div", {
    className: "user-cell"
  }, (0, _preact.h)("div", {
    className: "user-details-container"
  }, (0, _preact.h)("div", {
    className: "user-icon-container"
  }, (0, _preact.h)(_User.default, {
    width: 40,
    height: 40,
    className: "icon-user"
  })), (0, _preact.h)("div", {
    className: "user-details"
  }, (0, _preact.h)("div", {
    className: "user-placeholder"
  }), (0, _preact.h)("div", {
    className: "points-mobile"
  })))), (0, _preact.h)("div", {
    className: "points-cell"
  }, (0, _preact.h)("div", {
    className: "points-placeholder is-hidden-S"
  }), " ", (0, _preact.h)(_Medal.default, {
    className: "icon-medal mobile-medal-icon"
  }), ' '), (0, _preact.h)("div", {
    className: "rank-title-cell is-hidden-S is-hidden-tablet"
  }, (0, _preact.h)("div", {
    className: "rank-title-placeholder"
  })), (0, _preact.h)("div", {
    className: "badges-cell is-hidden-S is-hidden-tablet"
  }));
};

var LeaderboardUserRow = function LeaderboardUserRow(_ref4) {
  var user = _ref4.user,
      customClass = _ref4.customClass,
      isLoggedInUser = _ref4.isLoggedInUser;

  if (!user) {
    return null;
  }

  var id = user.id,
      name = user.name,
      avatar = user.avatar,
      points = user.points,
      leaderboardPosition = user.leaderboardPosition,
      rank = user.rank,
      rankTitle = user.rankTitle,
      badgeList = user.badgeList;
  var userData = (0, _utils.normalizeUserData)(id, name, avatar, rank, isLoggedInUser, false, rankTitle);
  var loggedInUserData = (0, _utils.normalizeUserData)(id, name, avatar, rank, isLoggedInUser, true, rankTitle);
  var leaderboardPositionToDisplay = (0, _utils.formatLeaderboardPosition)(leaderboardPosition, points);
  var isMedalVisible = leaderboardPosition !== null && leaderboardPosition <= 3;
  return (0, _preact.h)("div", {
    className: "leaderboard-row ".concat(customClass !== null && customClass !== void 0 ? customClass : '')
  }, (0, _preact.h)("div", {
    className: "ranking-cell right"
  }, ' ', isMedalVisible && (0, _preact.h)(_Medal.default, {
    className: "icon-medal icon-medal-".concat(leaderboardPosition, " is-hidden-S")
  }), (0, _preact.h)("span", {
    className: "ranking-number"
  }, " ", leaderboardPositionToDisplay, " "), (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking-wrapper"
  }, (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking"
  }, leaderboardPositionToDisplay), (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking-label"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.ranking"
  })))), (0, _preact.h)("div", {
    className: "user-cell"
  }, (0, _preact.h)("div", {
    className: "user-details-container"
  }, (0, _preact.h)("div", {
    className: "user-icon-container"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: userData,
    showRank: true,
    style: {
      display: 'block'
    }
  })), (0, _preact.h)("div", {
    className: "user-details"
  }, (0, _preact.h)(_UserName.default, {
    user: userData,
    extraClass: "username"
  }), (0, _preact.h)(_UserName.default, {
    user: loggedInUserData,
    extraClass: "logged-in-user-section-username"
  }), (0, _preact.h)("div", {
    className: "points-mobile"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "{n} point| {n} points",
    count: {
      n: points.toString()
    }
  }))))), (0, _preact.h)("div", {
    className: "points-cell"
  }, (0, _preact.h)("div", {
    className: "points-placeholder is-hidden-S"
  }, " ", points, " "), (0, _preact.h)("div", {
    className: "logged-in-user-section-points-wrapper"
  }, (0, _preact.h)("div", {
    className: "logged-in-user-section-points"
  }, points), (0, _preact.h)("div", {
    className: "logged-in-user-section-points-label"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.points"
  }))), isMedalVisible && (0, _preact.h)(_Medal.default, {
    className: "icon-medal mobile-medal-icon icon-medal-".concat(leaderboardPosition)
  })), (0, _preact.h)("div", {
    className: "rank-title-cell is-hidden-S is-hidden-tablet"
  }, rankTitle), (0, _preact.h)("div", {
    className: "badges-cell is-hidden-S is-hidden-tablet"
  }, (0, _preact.h)(BadgesColumn, {
    badges: badgeList
  })));
};

var LeaderboardHeaderRow = function LeaderboardHeaderRow() {
  return (0, _preact.h)("div", {
    className: "leaderboard-header-row is-hidden-S"
  }, (0, _preact.h)("div", {
    className: "ranking-cell right"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.ranking"
  })), (0, _preact.h)("div", {
    className: "user-cell"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.user"
  })), (0, _preact.h)("div", {
    className: "points-cell"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.points"
  })), (0, _preact.h)("div", {
    className: "rank-title-cell is-hidden-S is-hidden-tablet"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.rank"
  })), (0, _preact.h)("div", {
    className: "badges-cell is-hidden-S is-hidden-tablet"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.badges"
  })));
};

var BadgesColumn = function BadgesColumn(_ref5) {
  var badges = _ref5.badges;

  if (badges === undefined) {
    return null;
  }

  var badgeCount = badges.length;
  var numberOfBadgesToDisplay = 5;
  return (0, _preact.h)("div", {
    className: "badges-icon-container"
  }, (0, _preact.h)("div", null, badges.map(function (badge, idx) {
    return idx < numberOfBadgesToDisplay ? (0, _preact.h)("img", {
      className: "badge-icon",
      src: (0, _absoluteUrlRuntime.resolveUrl)(badge.icon),
      title: badge.title,
      alt: badge.title
    }) : null;
  })), (0, _preact.h)("div", null, " ", badgeCount <= numberOfBadgesToDisplay ? null : "+".concat(badgeCount - numberOfBadgesToDisplay)));
};